<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">Account Details</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" id="FTC_BTDFT_CRUD_4" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <div class="panel panel-default">
    <div class="panel-body">
      @if (loading) {
<div style="text-align: center; padding: 20px;">
        <i class="fa fa-spinner fa-pulse fa-2x"></i>
      </div>
}
      @if (!loading) {
<div>
        <table class="table table-striped blue">
          <thead>
            <tr>
              <th>Local Account</th>
              <th>Local Account Desc</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            @for (info of summaryInfo; track $index) {
<tr>
              <td>{{info.ACCT}}</td>
              <td>{{info.ACCT_DESC}}</td>
              <td [ngClass]="{'color-red': info.AMOUNT < 0}">{{numberWithCommas(info.AMOUNT)}}</td>
            </tr>
}
          </tbody>
        </table>
      </div>
}
    </div>
  </div>
</div>

